import { NetworkIcon } from 'elements/NetworkIcon';
import { NETWORK_IDS } from 'lib/constants';
import { omitBy } from 'lodash';
import { SignInOptions } from './types';

interface Props {
  returnTo?: string;
  errorTo?: string;
  text?: string;
}

export const onClickInstagramSignIn = (options: SignInOptions) => {
  // TODO: Switch back to instagram auth when app is reviewed by Meta
  // For now, use Facebook auth which gives access to Instagram business accounts
  const baseUrl = '/api/auth/facebook/signup';

  const allParams = {
    next: options.returnTo || '/',
    username: options.username,
    errorTo: options.errorTo,
    network: '4', // NETWORK_IDS.instagram = 4
  };
  const params = omitBy(allParams, (v) => !v) as Record<string, string>;
  const authUrl = `${baseUrl}?${new URLSearchParams(params).toString()}`;

  window.location.href = authUrl;
};

export const InstagramSignIn = ({ returnTo, text, errorTo }: Props) => {
  const onClick = () => onClickInstagramSignIn({
    returnTo,
    errorTo,
  });

  return (
    <button
      type="button"
      className="rounded-lg bg-black hover:bg-opacity-90 font-bold text-white text-xl w-full max-w-xs py-2"
      onClick={onClick}
    >
      <NetworkIcon
        style={{
          color: 'white',
          marginRight: '8px',
          verticalAlign: 'middle',
        }}
        network={NETWORK_IDS.instagram}
      />
      {text || 'Sign in with Instagram'}
    </button>
  );
};
